import React from 'react';

import { useSessionTokensState, useSessionTokensActions } from './SessionTokensContext';
import { deleteSessionToken } from './restApi';
import StandardModalLayout from '../../Shared/UI/StandardModalLayout/components/StandardModalLayout';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';

const DeleteSessionTokenForm = () => {
  const state = useSessionTokensState();
  const { onResponse, onError, closeDeleteSessionTokenModal } = useSessionTokensActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleDelete = () => {
    if (state?.sessionTokenToDelete) {
      deleteSessionToken({
        sessionTokenId: state.sessionTokenToDelete.id,
        pageNumber: state?.pageNumber || 1,
        onResponse: (response) => {
          closeDeleteSessionTokenModal();
          onResponse(response);
        },
        onError,
        body: {
          authenticityToken,
        },
      });
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const modalBody = (
    <div>
      <p style={{ marginBottom: '1rem' }}>
        Are you sure you want to delete this session token? The user will be logged out immediately.
      </p>
      {state?.sessionTokenToDelete && (
        <div style={{ 
          background: '#f5f5f5', 
          padding: '1rem', 
          borderRadius: '4px',
          fontSize: '0.9em'
        }}>
          <p><strong>User:</strong> {state.sessionTokenToDelete.userEmail}</p>
          <p><strong>Remote IP:</strong> {state.sessionTokenToDelete.remoteIp}</p>
          <p><strong>Created:</strong> {formatDate(state.sessionTokenToDelete.createdAt)}</p>
        </div>
      )}
    </div>
  );

  const modalFooter = (
    <ResponsiveContainer name="form-actions">
      <FormActions>
        <Button
          variant="secondary"
          onClick={() => closeDeleteSessionTokenModal()}
        >
          Cancel
        </Button>
        <Button
          variant="destructive"
          onClick={handleDelete}
        >
          Delete Session Token
        </Button>
      </FormActions>
    </ResponsiveContainer>
  );

  return (
    <StandardModalLayout
      body={modalBody}
      footer={modalFooter}
    />
  );
};

export default DeleteSessionTokenForm;
